import { OrderAttributes, OrderDetailAttributes, OrderDetailBatchesAttributes, TripBatchesAttributes, WarehouseAttributes } from '@albatrosdeveloper/ave-models-package';
import AlternalUnitMeasurementAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/materials/material/alternal-unit-measure/alternal-unit-measure.entity';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, Inject, TemplateRef, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatTooltip, MatTooltipModule } from '@angular/material/tooltip';
import { DeleteConfirmationComponent } from 'app/modules/components/business-partners/business-partner/delete-modal/delete-modal.component';
import { CompanyService } from 'app/modules/components/configuration/company/company.service.service';
import { WarehouseService } from 'app/modules/components/configuration/warehouse/warehouse.service';
import { MaterialUnitMeasureService } from 'app/modules/components/material/material/material-unit-alternate.service';
import { MaterialService } from 'app/modules/components/material/material/material.service';
import { OrdersListService } from 'app/modules/components/sales/order-list-components/order-list.service';
import { PermissionService } from 'app/core/permission';
import { ManualLabelSelectionIndicatorComponent } from 'app/shared/components/manual-label-selection-indicator';

@Component({
  selector: 'app-batches-detail',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatTableModule,
    MatButtonModule,
    MatIcon,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatTooltipModule,
    MatSelectModule,
    ManualLabelSelectionIndicatorComponent
  ],
  templateUrl: './batches-detail.component.html',
  styleUrl: './batches-detail.component.scss',
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({
        height: '0',
        minHeight: '0',
        padding: '0',
        margin: '0',
        visibility: 'hidden',
        opacity: '0',
        border: 'none'
      })),
      state('expanded', style({
        height: '*',
        visibility: 'visible',
        opacity: '1',
        padding: '1rem'
      })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ]
})

export class BatchesDetailComponent {

  expandedElement: any | null;
  displayedColumnsBatches: string[] = ['expand', 'batch', 'umb', 'ump', 'warehouse', 'price', 'actions'];
  displayedColumnsDetail = ['batch', 'umb', 'ump', 'actions'];
  dataSourceBatches = new MatTableDataSource<any>([]);

  UMPActive: boolean = false;
  newBatch: boolean = false;

  warehouseList: WarehouseAttributes[] = [];
  alternalUnitOfMeasures: AlternalUnitMeasurementAttributes[] = [];

  @ViewChild("invoiceModal") invoiceModal!: TemplateRef<any>;
  dialogInvoiceRef!: MatDialogRef<any>;
  selectedBatch: any = null;
  invoiceList: any[] = [];
  emptyBatchTemplate = {
    bacth: '',
    quantity: 0,
    parallelQuantity: 0,
    warehouse: null,
    invoice: null,
    labels: [],
    expanded: false
  };

  constructor(
    private readonly ordersListService: OrdersListService,
    private readonly companyService: CompanyService,
    private readonly warehouseService: WarehouseService,
    private readonly materialUnitService: MaterialUnitMeasureService,
    private readonly snackBar: MatSnackBar,
    private cdr: ChangeDetectorRef,
    private dialog: MatDialog,
    private readonly permissionService: PermissionService,
    public dialogRef: MatDialogRef<BatchesDetailComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      order: any,
      data: OrderDetailAttributes,
      type: string,
      isEdit: boolean,
      isChangeCostBatch: boolean,
      // Codigo del permiso de edicion de la pantalla que abre el modal. Este
      // componente lo comparten ocho listados y cada uno tiene el suyo, por eso
      // no puede venir cableado aca dentro.
      updatePermission?: string,
    }
  ) {
  }

  async ngOnInit() {
    await this.fetchMaterial();
    await this.fetchCompanies();
    if (this.data.type === 'normal') {
      this.dataSourceBatches.data = this.data.data.batches ?? []
    } else {
      // Los documentos anteriores a la selección manual de etiquetas no tienen
      // `deliveredBatches`; mostrar lo cargado evita abrir el modal en blanco.
      const delivered = this.data.data.deliveredBatches ?? [];
      this.dataSourceBatches.data = delivered.length > 0 ? delivered : (this.data.data.batches ?? []);
    }
    if (this.data.isChangeCostBatch) {
      this.fetchWarehouses();
    }
    this.setDisplayedColumns();
    this.setDisplayedColumnsDetail();
  }

  get canEdit(): boolean {
    return !this.data?.updatePermission || this.permissionService.has(this.data.updatePermission);
  }

  addNewBatch() {
    const newBatch = JSON.parse(JSON.stringify(this.emptyBatchTemplate));
    this.dataSourceBatches.data = [...this.dataSourceBatches.data, newBatch];
    this.dataSourceBatches._updateChangeSubscription(); // Actualizar la tabla
  }

  deleteBatch(index: number) {
    this.dataSourceBatches.data.splice(index, 1);
    this.dataSourceBatches._updateChangeSubscription();
  }

  addLabelToBatch(batch: any, index: number): void {
    if (!batch.labels) {
      batch.labels = [];
    }

    const newLabel = {
      label: '',
      quantity: 0,
      parallelQuantity: 0
    };

    batch.labels = [...batch.labels, newLabel];

    batch.expanded = true; // expandir para mostrar la tabla anidada

    this.dataSourceBatches._updateChangeSubscription();
  }

  async fetchCompanies(): Promise<void> {
    const res = await this.companyService.findToComboBox().toPromise();
    if (res.data.length === 1) {
      this.UMPActive = res.data[0].UMPActive

      if (!this.UMPActive) {
        this.displayedColumnsDetail = ['batch', 'umb', 'actions'];
      }
    }
  }

  async fetchMaterial(): Promise<void> {
    this.materialUnitService
      .findByMaterialId(this.data.data.material._id.toString())
      .subscribe((data) => {
        this.alternalUnitOfMeasures = data?.data;
      });
  }

  private fetchWarehouses(): void {
    this.warehouseService.findToComboBox().subscribe({
      next: (res) => {
        this.warehouseList = res.data || [];
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener almacenes.","Cerrar",{ duration: 5000});
      }
    })
  }

  setDisplayedColumns(): void {
    const baseColumns = ['expand', 'batch', 'umb'];
    if (this.UMPActive !== false) {
      baseColumns.push('ump');
    }

    if (this.data.isChangeCostBatch) {
      baseColumns.push('warehouse', 'price', 'actions');
    }

    this.displayedColumnsBatches = baseColumns;
  }

  setDisplayedColumnsDetail(): void {
    const baseColumns = ['batch', 'umb'];
    if (this.UMPActive !== false) {
      baseColumns.push('ump');
    }

    if (this.data.isChangeCostBatch) {
      baseColumns.push('actions');
    }

    this.displayedColumnsDetail = baseColumns;
  }

  getDisplayedColumns(): string[] {
    return this.displayedColumnsBatches.concat(
      this.dataSourceBatches.data.some(b => b.labels && b.labels.length > 0) ? ['expand'] : []
    );
  }

  onSubmit() {
    const isValid = this.dataSourceBatches.data.every(batch => this.checkBatchQuantities(batch));

    if (isValid) {
      this.updateOrder(this.dataSourceBatches.data);
    } else {
      this.snackBar.open('Hay lotes y/o etiquetas con cantidades inconsistentes. Por favor revisa los datos.', 'Cerrar', {
        duration: 3000,
      });
    }
  }

  // checkBatchQuantities(batch: any): boolean {
  //   if (!batch.labels || batch.labels.length === 0) {
  //     return true;
  //   }

  //   const totalQuantity = batch.labels.reduce((acc, label) => acc + (label.quantity || 0), 0);
  //   const totalParallelQuantity = batch.labels.reduce((acc, label) => acc + (label.parallelQuantity || 0), 0);

  //   return totalQuantity === batch.quantity && totalParallelQuantity === batch.parallelQuantity;
  // }


  checkBatchQuantities(batch: any): boolean {
    // 1. Validación individual del batch (si tiene labels)
    if (batch.labels?.length > 0) {
      const totalQuantity = batch.labels.reduce((acc, l) => acc + (l.quantity || 0), 0);
      const totalParallelQuantity = batch.labels.reduce((acc, l) => acc + (l.parallelQuantity || 0), 0);

      if (totalQuantity !== batch.quantity || totalParallelQuantity !== batch.parallelQuantity) {
        return false;
      }
    }

    // 2. Validación global de todos los batches
    const allBatches = this.dataSourceBatches.data;
    const totalBatchQuantity = allBatches.reduce((sum, b) => sum + (b.quantity || 0), 0);
    const totalBatchParallelQuantity = allBatches.reduce((sum, b) => sum + (b.parallelQuantity || 0), 0);

    return totalBatchQuantity === this.roundToX(this.data.data.baseQuantity,3) &&
      totalBatchParallelQuantity === this.roundToX(this.data.data.pararellQuantity,3);
  }

  updateOrder(dataSource) {
    if (!this.data.order || !this.data.data) {
      return;
    }

    const key = this.data.type === 'normal' ? 'batches' : 'deliveredBatches';
    const detailIndex = this.data.order.detail.findIndex(d => d.position === this.data.data.position);

    if (detailIndex !== -1) {
      const cleanedDataSource = dataSource.map(batch => {
        const { invoice, ...rest } = batch;
        return rest;
      });

      this.data.order.detail[detailIndex][key] = cleanedDataSource;
    }

    const filteredDetail = this.data.order.detail.map(item => {
      const base = {
        position: item.position,
        [key]: item[key] ?? [],
      };

      if (this.data.isChangeCostBatch) {
        return {
          ...base,
          unitPrice: item.unitPrice
        };
      }

      return base;
    });

    const send = {
      detail: filteredDetail
    };

    this.ordersListService.updateV2(String(this.data.order._id), send).subscribe({
      next: () => {
        this.snackBar.open("Registro actualizado con éxito", "Cerrar", { duration: 3000, });
        this.dialogRef.close({ saved: true, detailId: this.data.data.position });
        this.cdr.detectChanges();
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al actualizar el registro", "Cerrar", { duration: 3000 });
      },
    });
  }

onClose(): void {
   this.dialogRef.close({ saved: false, detailId: this.data.data.position });
}

  async deleteLabel(batch: any, rowIndex: number) {
    const confirm = await this.dialog.open(DeleteConfirmationComponent, {
      data: {
        title: 'Confirmar eliminación',
        message: `¿Estás seguro de eliminar la etiqueta?`
      }
    }).afterClosed().toPromise();

    if (confirm) {
      const newLabels = [...batch.labels];
      newLabels.splice(rowIndex, 1);
      batch.labels = newLabels;
      this.dataSourceBatches.data = this.dataSourceBatches.data.map(b =>
        b === batch ? { ...b, labels: newLabels } : b
      );
    }
  }

  trackByLabelFn(index: number, item: any): number {
    return index;
  }

  trackBy(index: number, item: any): number {
    return index;
  }

  hasAnyInvoiceSelected(): boolean {
    return this.data?.order?.detail?.some(detail =>
      detail.batches?.some(batch => !!(batch as any).invoice)
    );
  }

  openInvoiceDialog(batch: OrderDetailBatchesAttributes) {
    this.selectedBatch = batch ? batch : null;

    /* let send ={
      productCode: this.data.data.material?.code,
      customerCode: "9500875", // this.data.order.shipTo.externalKeys?.code,
      loteCode: batch ? [batch.bacth] : this.dataSourceBatches.data.map((b: any) => b.bacth)
    } */

    let send = {
      "productCode": "9342025800", "customerCode": "9500875", "loteCode": ["2098634"]
    }

    this.ordersListService.getListInvoices(send).subscribe({
      next: (res: any) => {
        this.invoiceList = res || [];
        this.dialogInvoiceRef = this.dialog.open(this.invoiceModal, { width: "90%", disableClose: true });
      }, error: (err) => {
        this.invoiceList = []
      }
    });
  }

  selectInvoice(invoice: any) {
    if (!invoice) return;

    if (this.selectedBatch) {
      this.selectedBatch.invoice = invoice;
    } else {
      this.dataSourceBatches.data.forEach((batch: any) => {
        batch.invoice = invoice;
      });
    }

    const detail = this.data.order.detail.find(d =>
      d.position === this.data.data.position
    );

    if (detail) {
      detail.unitPrice = Number(invoice.price) || 0;
      this.onChangePriceInOrderDetail(this.data.order, detail);
    }
    this.dialogInvoiceRef.close();
  }

  onChangePriceInOrderDetail(
    order: OrderAttributes,
    orderDetail: OrderDetailAttributes
  ): void {
    if (orderDetail.unitPrice < 0) {
      orderDetail.unitPrice = 0;
      this.snackBar.open(
        "El precio no debe ser menor a cero.",
        "Cerrar",
        { duration: 3000 }
      );
    }
    this.onChangeSubTotalInOrderDetail(order, orderDetail);
  }

  onChangeSubTotalInOrderDetail(
    order: OrderAttributes,
    orderDetail: OrderDetailAttributes
  ): void {
    if (orderDetail.soldQuantity < 0) {
      orderDetail.soldQuantity = 0;
      this.snackBar.open(
        "La cantidad no debe ser menor a cero.",
        "Cerrar",
        { duration: 3000 }
      );
    }

    orderDetail.subTotal = orderDetail.unitPrice * orderDetail.soldQuantity;
    // Calcula descuentos
    orderDetail.totalDiscounts = 0;
    if (orderDetail.discounts && orderDetail.discounts.length > 0) {
      orderDetail.totalDiscounts = orderDetail.discounts.reduce(
        (acc, discount) => {
          switch (discount.type) {
            case 'PERCENTAGE':
              return acc + (orderDetail.subTotal * discount.discount) / 100;
            case 'AMOUNT':
              return acc + discount.discount;
            default:
              return acc;
          }
        },
        0
      );
    }

    orderDetail.subTotalBeforeTaxes =
      orderDetail.subTotal -
      orderDetail.totalDiscounts +
      orderDetail.totalSurcharges;

    // Calcula impuestos
    orderDetail.totalTaxes = 0;
    if (orderDetail.taxes && orderDetail.taxes.length > 0) {
      orderDetail.totalTaxes = orderDetail.taxes.reduce(
        (acc, tax) =>
          acc + (orderDetail.subTotalBeforeTaxes * tax.percentage) / 100,
        0
      );
    }

    orderDetail.total =
      orderDetail.subTotalBeforeTaxes + orderDetail.totalTaxes;
  }

  onQuantityParallelChange(batches): void {
    const quantity = batches.quantity;
    const factor = this.getConversionFactor();
    batches.parallelQuantity = quantity && factor ? quantity / factor : 0;
    batches.parallelQuantity = this.roundToX(batches.parallelQuantity, 3);
  }

  roundToX(value: number, decimals: number) {
    return parseFloat(value.toFixed(decimals));
  }

  getConversionFactor(): number {

    if (!this.alternalUnitOfMeasures) return 1;

    const altUom = this.alternalUnitOfMeasures.find(uom => uom.isUMP);

    return altUom?.conversionFactor || 1;
  }
}
